import { FC, useCallback } from "react";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useBreakPenalty } from "@sinch/components/application/RateInterval/CreateInterval/BreakPenalty/BreakPenaltyProvider";
import { DurationInput } from "@sinch/components/form/DurationInput/DurationInput";
import { useMuiController } from "@sinch/components/index";

/**
 * How long the required break has to be, which is also the penalty as long as it is not custom
 */
export const BreakRequiredLengthField: FC = () => {
  const { t } = useTranslation();
  const { path, disabled, syncPenaltyWithBreak } = useBreakPenalty();
  const { field } = useMuiController<FieldValues, string>({ name: `${path}.breakMinutes`, disabled });

  const handleChange = useCallback(
    (minutes: number | null) => {
      field.onChange(minutes);
      syncPenaltyWithBreak(minutes);
    },
    [field, syncPenaltyWithBreak]
  );

  return (
    <DurationInput {...field} fullWidth label={t("RateUnit.breakRequiredLength")} min={1} onChange={handleChange} />
  );
};
